const _queryString = window.location.search;
export const _urlParams = new URLSearchParams(_queryString);

export const _DEBUG = _urlParams.get('debug') == 1 ? true : false;
